module.exports = __webpack_public_path__ + "assets/datadome.4d2a601b.svg";